import { Provider, makeEnvironmentProviders } from '@angular/core';
import { SVG_ICON_REGISTRY_PROVIDER } from './icon-registry.service';
import { SvgHttpLoader, SvgLoader } from './svg-loader';

export interface IconConfig {
  loader?: Provider;
}
export const provideSvgIcon = (config: IconConfig = {}) =>
  makeEnvironmentProviders([
    SVG_ICON_REGISTRY_PROVIDER,
    config.loader || { provide: SvgLoader, useClass: SvgHttpLoader },
  ]);
